<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:preliminary.type_select.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("af:preliminary.type_select.description") }}
    </p>

    <p class="has-text-weight-bold mt-5 mb-2">
      {{ $t("af:preliminary.type_select.benefits.title") }}
    </p>

    <div class="mb-1 is-flex">
      <b-icon icon-pack="fa" icon="money-bill" type="is-grey-icon"></b-icon>
      <span class="ml-1 mt-1">
        {{ $t("af:preliminary.type_select.benefits.one.label") }}
      </span>
    </div>

    <div class="mb-1 is-flex">
      <b-icon icon-pack="fa" icon="file-alt" type="is-grey-icon"></b-icon>
      <span class="ml-1 mt-1">
        {{ $t("af:preliminary.type_select.benefits.two.label") }}
      </span>
    </div>

    <p class="has-text-weight-bold mt-5 mb-2">
      {{ $t("af:preliminary.type_select.select.title") }}
    </p>

    <div
      id="prelimTypePSD2"
      class="prelim-type-selector mt-5"
      @click="onPsd2Select"
      :class="{ 'prelim-type-selector-selected': psd2Selected }"
    >
      <div class="is-flex mb-3">
        <b-icon
          icon-pack="fa"
          icon="landmark"
          size="is-large"
          :class="{
            'is-blue-icon': psd2Selected,
            'is-grey-icon': !psd2Selected,
          }"
        ></b-icon>

        <div class="is-flex is-flex-direction-column ml-2">
          <div class="is-flex mb-0">
            <span class="has-text-weight-bold">
              {{ $t("af:preliminary.type_select.input.psd2.title") }}
            </span>
          </div>
          <span class="has-text-grey">
            {{ $t("af:preliminary.type_select.input.psd2.description") }}
          </span>
        </div>

        <b-icon
          pack="far"
          :icon="psd2Selected ? 'check-circle' : 'circle'"
          size="is-medium"
          class="select-icon"
          :class="{ 'is-blue-icon': psd2Selected }"
        />
      </div>

      <div class="ml-2 mb-3">
        {{ $t("af:preliminary.type_select.input.psd2.content") }}
      </div>

      <div class="ml-2 mb-2">
        <b-icon
          icon="check-circle"
          :class="{
            'is-blue-icon': psd2Selected,
            'is-green-icon': !psd2Selected,
          }"
        ></b-icon>

        {{ $t("af:preliminary.type_select.input.psd2.line_one") }}
      </div>

      <div class="ml-2 mb-2">
        <b-icon
          icon="check-circle"
          :class="{
            'is-blue-icon': psd2Selected,
            'is-green-icon': !psd2Selected,
          }"
        ></b-icon>

        {{ $t("af:preliminary.type_select.input.psd2.line_two") }}
      </div>

      <div class="ml-2">
        <b-icon
          icon="check-circle"
          :class="{
            'is-blue-icon': psd2Selected,
            'is-green-icon': !psd2Selected,
          }"
        ></b-icon>

        {{ $t("af:preliminary.type_select.input.psd2.line_three") }}
      </div>
    </div>

    <div
      id="prelimTypeManual"
      class="prelim-type-selector mt-5"
      @click="onManualSelect"
      :class="{ 'prelim-type-selector-selected': manualSelected }"
    >
      <div class="is-flex mb-3">
        <b-icon
          icon-pack="fa"
          icon="keyboard"
          size="is-large"
          :class="{
            'is-blue-icon': manualSelected,
            'is-grey-icon': !manualSelected,
          }"
        ></b-icon>

        <div class="is-flex is-flex-direction-column ml-2">
          <div class="is-flex mb-0">
            <span class="has-text-weight-bold">
              {{ $t("af:preliminary.type_select.input.manual.title") }}
            </span>
          </div>
          <span class="has-text-grey">
            {{ $t("af:preliminary.type_select.input.manual.description") }}
          </span>
        </div>

        <b-icon
          pack="far"
          :icon="manualSelected ? 'check-circle' : 'circle'"
          size="is-medium"
          class="select-icon"
          :class="{ 'is-blue-icon': manualSelected }"
        />
      </div>

      <div class="ml-2 mb-3">
        {{ $t("af:preliminary.type_select.input.manual.content") }}
      </div>
    </div>
  </div>
</template>

<script>
import { PRELIM_TYPE } from "../../utils/const";
import { mapGetters } from "vuex";
import eventBus, { EVENTS } from "../../utils/eventBus";

export default {
  name: "PreliminaryTypeSelector",
  components: {},
  props: {},
  data() {
    return {
      psd2Selected: false,
      manualSelected: false,
    };
  },
  async created() {
    this.psd2Selected =
      this.$store.getters["preliminaryAssessment/answer"](PRELIM_TYPE.KEY) ===
      PRELIM_TYPE.PSD2;
    this.manualSelected =
      this.$store.getters["preliminaryAssessment/answer"](PRELIM_TYPE.KEY) ===
      PRELIM_TYPE.MANUAL;
  },
  computed: {
    ...mapGetters({
      type: "preliminaryAssessment/getType",
    }),
  },
  methods: {
    async onPsd2Select() {
      eventBus.$emit(EVENTS.PRELIM_TYPE_CHANGED, true);
      this.psd2Selected = true;
      this.manualSelected = false;
      this.storeData(PRELIM_TYPE.KEY, PRELIM_TYPE.PSD2);
      await this.fetchSteps();
      eventBus.$emit(EVENTS.PRELIM_TYPE_CHANGED, false);
    },
    async onManualSelect() {
      eventBus.$emit(EVENTS.PRELIM_TYPE_CHANGED, true);
      this.manualSelected = true;
      this.psd2Selected = false;
      this.storeData(PRELIM_TYPE.KEY, PRELIM_TYPE.MANUAL);
      await this.fetchSteps();
      eventBus.$emit(EVENTS.PRELIM_TYPE_CHANGED, false);
    },
    storeData(questionId, answer) {
      this.$store.dispatch("preliminaryAssessment/addData", {
        question: questionId,
        answer: answer,
      });
    },
    async fetchSteps() {
      await this.$store.dispatch("preliminaryAssessment/fetchSteps", this.type);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.prelim-type-selector {
  padding: 1rem;
  border: 1px solid #d1d8e0;
  border-radius: 16px;
  cursor: pointer;
  user-select: none;

  &-selected {
    border: 1px solid $blue;
    background: #f5f7fb;
  }
}

.select-icon {
  top: -10px;
  right: -10px;
  position: relative;
  margin-left: auto;

  &:not(.is-blue-icon) {
    color: #d1d8e0;
  }
}
</style>
